// extracted by mini-css-extract-plugin
export var toggleButton = "styles-module--toggle-button--cb2b9";
export var toggleDescription = "styles-module--toggle-description--87e2e";
export var toggleLabel = "styles-module--toggle-label--5f510";
export var toggleLabelDisabled = "styles-module--toggle-label-disabled--c5660";
export var toggleWrapper = "styles-module--toggle-wrapper--ff36a";